import type { Article } from '../types'

export const article: Article = {
  meta: {
    slug: 'chalupa-do-hodiny-z-prahy',
    title: 'Chalupa do hodiny z Prahy: víkend, který začne hned po práci',
    metaTitle: 'Chalupa do hodiny z Prahy na víkend',
    perex:
      'Vyjedete v pátek po šesté a před setměním sedíte na zahradě s otevřeným pivem. Do hodiny od Prahy je řeka, les i skála – a víkend, na který si nemusíte brát dovolenou.',
    coverImage: 'https://images.unsplash.com/photo-1642372133103-a02584dc43c1?w=1200&q=80&auto=format&fit=crop',
    coverImageAlt: 'Silnice s alejí vedoucí venkovskou krajinou při západu slunce, nad ní hejno ptáků',
    publishedAt: '2026-07-29',
    author: 'Redakce Mátevolno',
    tags: ['výlet z Prahy', 'víkend', 'střední Čechy'],
  },
  content: `Vyjedete v pátek po šesté, jednou zastavíte u benzínky a ještě za světla otevíráte vrátka od zahrady. Žádná noční jízda přes půl republiky, žádné „dojedeme až po jedenácté". Do hodiny od Prahy je řeka, les i skála – jen se o tom málo mluví, protože všichni koukají na hory.

> Dvě hodiny na cestě tam a zpět jsou na dvoudenním výletě celý jeden večer.

## Krátká cesta je nejlevnější způsob, jak si prodloužit víkend

Víkend má zhruba padesát hodin. Když na cestu obětujete pět, zbyde vám čtyřicet pět – a půlku z toho prospíte. Chalupa do hodiny od Prahy tenhle účet obrací: dorazíte v pátek na večeři, ne na půlnoční čaj, a v neděli můžete odjíždět po obědě, protože doma jste stejně dřív než u sousedů z dálnice.

Vedle času šetříte i nervy. Netahá se s vámi vyčerpaná posádka, děti neusnou dvacet minut před cílem a auto nemusí být nacpané tak, jako když jedete na týden. Na dvě noci stačí jedna taška a chleba z pekárny.

::nabidky{region="stredni-cechy" text="Prohlédnout pobyty ve středních Čechách"}

## Co je do hodiny od Prahy

Nejde o jedno místo, ale o čtyři úplně různé krajiny – vyberete si podle toho, co od víkendu chcete:

- **Posázaví** – řeka, lesy a vlak, který jede podél vody. Ideální na kánoe, ale i na dva dny bez plánu.
- **Berounsko a Křivoklátsko** – hluboké lesy, hrady a skály nad Berounkou. Nejlepší volba, když chcete chodit pěšky.
- **Slapy a dolní Vltava** – voda, mola a strmé zalesněné břehy. V létě sem jezdíte plavat, na podzim za tichem.
- **Kokořínsko a Polabí** – pískovcové rokle, pokličky a rovinatá krajina na kolo. Kousek od Prahy, a přitom úplně jiný svět.

## Než rezervujete

Blízkost má i své zvláštnosti. Pár věcí, které se vyplatí ohlídat:

- **Hlídejte skutečnou dobu jízdy, ne vzdušnou čáru.** Padesát kilometrů po dálnici je půl hodiny, po okreskách přes Brdy klidně hodina a půl.
- **Počítejte s pátečním provozem.** Výjezd z Prahy mezi čtvrtou a šestou umí přidat půl hodiny. Vyrazit v sedm bývá rychlejší než v pět.
- **Ptejte se na minimální počet nocí.** Blízké chalupy jsou žádané právě na dva dny, takže bývají na víkend rychle pryč – a naopak se u nich častěji uvolní termín na poslední chvíli.
- **Ověřte si, co je v okolí otevřené.** Obchod, hospoda a pekárna do pěti kilometrů udělají z dvoudenního pobytu dovolenou, ne výpravu za nákupem.

## Nejbližší volný víkend

Na chalupu hodinu od Prahy nepotřebujete plán ani dovolenou – stačí pátek, který zrovna nikam nepatří:

::cta{text="Prohlédnout pobyty ve středních Čechách" region="stredni-cechy"}`,
}
